import FormPages from "src/EstateFlowchart/config/FormPages";
import { EstateFlowchartState } from "src/EstateFlowchart/model/EstateFlowchartTypes";
import { Miscellaneous } from "../../model/Miscellaneous";
import { validateBasicInformation } from "../page/BasicInformationValidator";
import { FormValidationErrors, ValidationError } from "../ValidationTypes";


/**
 * Validates the Miscellaneous form based on the miscellaneous data.
 * @param {Miscellaneous} miscellaneous - The miscellaneous data to validate against.
 * @returns {{formHasErrors: boolean, errors: ValidationError[]}} An object containing a boolean indicating if the form has errors and an array with the specific errors.
 */
export const validateMiscellaneousForm = (
    pageName: string | undefined, 
    miscellaneous: Miscellaneous | undefined,
    flowcharts: EstateFlowchartState[],
    flowchartId: string,
    enableEstateFlowchartMVPRelease: boolean
): FormValidationErrors => {
    let errors: ValidationError[] = [];

    if (miscellaneous) {
        if (pageName == FormPages.BASIC_INFORMATION.id) {
                errors = validateBasicInformation(miscellaneous, flowcharts, flowchartId, enableEstateFlowchartMVPRelease);
        }
    }

    return {
        formHasErrors: errors.length > 0,
        errors
    };
};
